export default __webpack_public_path__ + "static/media/ball.26e05b6a.wav";